import { getStore } from '~/mobx/AppStore';

const getUserFullName = () => {
    const { userStore } = getStore();
    return userStore.user?.given_name + ' ' + userStore.user?.family_name;
};

export default getUserFullName;
